import  { useContext, useEffect, useRef, useState } from "react";
import { Switch, Route, useHistory, useRouteMatch, useLocation } from "react-router-dom";

import { IonItem, IonToolbar, IonLabel, IonButtons, IonSegmentButton, IonSegment, IonItemDivider, IonNote, IonPage, IonHeader, IonContent, IonFooter, isPlatform, IonSearchbar, IonButton } from "@ionic/react";
import { BookContent, Colour, FontType, SearchHistory } from "../global";
import Part from "./chapters";
import { QueueMusicSharp, MenuBookSharp, HighlightOff, MenuBook, MusicNote } from "@mui/icons-material";
import { AnimatePresence, motion } from "framer-motion";
import { AutoStoriesSharp, PlayLessonSharp } from "@mui/icons-material";
import SP from "../../sp.svg";
import { useLocal } from "../lshooks";

function Book() {
 let { path, url } = useRouteMatch();

 let history = useHistory();
 let location = useLocation();
 const [clr, ] = useContext(Colour);
 let color,color2,color3,colori,colorh,colorsp, color4;
 if(clr === "1") {
  color = "dark";
  color2 = "#00CBFE";
  color3 = "white"
  colori = ""
  colorh = "primary"
  colorsp = "#3880ff"
  color4 = "black"
 }
 if(clr === "2") {
  color = "dark";
  color2 = "#FFE34D";
  color3 = "black"
  colori = "secondary"
  colorh = "warning"
  colorsp = "#F5CA16"
  color4 = "black"
 }
 if(clr === "3") {
  color = "dark";
  color2 = "#FFA500";
  color3 = "black"
  colori = "secondary"
  colorh = "success"
  colorsp = "#FF9933"
  color4 = "black"
 }
 if(clr === "4") {
  color = "dark";
  color2 = "#87CEEB";
  color3 = "black"
  colori = "secondary"
  colorh = "tertiary"
  colorsp = "#6FB1FC"
  color4 = "black"
 }
 if(clr === "5") {
  color = "light";
  color2 = "#FFE34D";
  color3 = "black"
  colori = "dark"
  colorh = "warning"
  colorsp = "#F5CA16"
  color4 = "white"
 }
 if(clr === "6") {
  color = "light";
  color2 = "#87CEEB";
  color3 = "black"
  colori = "dark"
  colorh = "tertiary"
  colorsp = "#6FB1FC"
  color4 = "white"
 }
 const [font, ] = useContext(FontType);
 let fon;
 if (!font) fon = "Calibri, sans-serif";
 else fon = "Times New Roman, serif";
 const [spos, setSpos] = useState(0);
 let locy = 0;
 const contentRef = useRef();
 const [searchText, setSearchText] = useState("");
 const [searchState, setSearchState] = useState(false);
 const [searchList, setSearchList] = useState([]);
 const [searchHistory, setSearchHistory] = useContext(SearchHistory)
 const [listView, setListView] = useLocal("books-view",false)
 const [songsList, setSongsList] = useState([])
 const [dsongsList, setDsongsList] = useState([])
 const content = useContext(BookContent);
 let scrollBar= ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "R", "S", "T", "U", "V", "Y"];
 useEffect(() => {
    if (location.pathname === url && contentRef.current) contentRef.current.scrollToPoint(0,spos);
 }, [location, contentRef.current]);

 useEffect(()=>{
  let songs = [];
  for (let i=0; i<content.length; i++){
    if (content[i].chap.length > 0){
      for (let j=0; j<content[i].chap.length; j++){
      for (let k=0; k<content[i].chap[j].song.length; k++){
        songs.push({name: content[i].chap[j].song[k].name.slice(3).trimStart().normalize("NFD").replace(/[\u0300-\u036f]/g, ""), book:`${content[i].name} (Chap. ${j+1})`, i:i, j:j, k:k, link: `${content[i].name}/${j}/${k}`, audio: content[i].chap[j].song[k].vname ? true : false  })
      }
    }
  }else{
    for (let k=0; k<content[i].song.length; k++){
      songs.push({name: content[i].song[k].name.slice(3).trimStart().normalize("NFD").replace(/[\u0300-\u036f]/g, ""), book:content[i].name, i:i, k:k, link: `${content[i].name}/${k}`, audio: content[i].song[k].vname ? true : false  })
    }
  }
   }
   songs.sort((a, b) => {
    const nameA = a.name.toLowerCase();
    const nameB = b.name.toLowerCase();

    if (nameA < nameB) {
        return -1;
    }
    if (nameA > nameB) {
        return 1;
    }
    return 0;
});
setDsongsList(songs)

 },[])


 useEffect(()=>{
  if(listView){
    setSongsList(dsongsList.slice(0, 20))
    setTimeout(function () {
      setSongsList([...dsongsList]);
     }, 1);
  }else{
    setSongsList([])
  }
 },[listView, dsongsList])

 const search = (text)=>{
 
  setSearchText(text)
  window.scrollTo(0, 0);
  let query = text
   .toLowerCase()
   .replace(/[.,/#!$%^&*;:{}=\-_`~()]/g, " ")
   .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
   .replace(/krishna/g, "krsna")
   .replace(/gor/g, "gaur")
   .replace(/gour/g, "gaur")
   .replace(/\s{2,}/g, " ");


   let titles = [];
   let songsList = dsongsList;
   for (let i=0; i<songsList.length; i++){
    let song_text = (songsList[i]["j"] >=0 ? content[songsList[i]["i"]]["chap"][songsList[i]["j"]]["song"][songsList[i]["k"]]["body"] : content[songsList[i]["i"]]["song"][songsList[i]["k"]]["body"]).replace(/krishna/g, "krsna")
    .replace(/gor/g, "gaur")
    .replace(/gour/g, "gaur")
    .toLowerCase().replace(/[.,/#!$%^&*;:{}=\-_`~()]/g, " ").normalize("NFD").replace(/[\u0300-\u036f]/g, "");

    let query_index = song_text.indexOf(query)
    if(songsList[i].name.toLowerCase().indexOf(query) !== -1) {
      titles.push({name: songsList[i].name,link: songsList[i].link, book: songsList[i].book,  title: true})
    }
    if (query_index !== -1) {
      let line = song_text.slice(song_text.lastIndexOf("\n", query_index), song_text.indexOf("\n", query_index))
      let query_start = line.indexOf(query)
      titles.push({name: songsList[i].name,link: songsList[i].link, line: line, start: query_start, end: query_start+query.length})
    }
    

   }
   setSearchList(titles);
 
 }
 return (
  <AnimatePresence onExitComplete>
    <>
    <div className="print-hide">
    <IonPage>
    <IonHeader>
     <IonToolbar color={colorh}>

     <IonSearchbar
          color={colori}
          value={searchText}
          placeholder="Search in Song Books"
          style={{ padding:"0 0 0 10px"}}
          type="text"
          onIonInput={(e) => {
           search(e.detail.value)
          }}
          debounce={1000}
          onIonFocus={()=>{
            setSearchState(true)
          }}
          onIonClear={() => {
           window.scrollTo(0, 0);
          }}
         ></IonSearchbar>
                  {searchState ? (
          <IonButtons style={{height:"52px", margin: "0 10px"}} slot="end">
           <IonButton
            onClick={(e) => {
              setSearchText("");
              setSearchState(false);
            }}
           >
            <HighlightOff />
           </IonButton>
          </IonButtons>
         ) : (
          <IonButtons style={{height:"52px", margin: "0 10px"}} slot="end">
           

        <IonButton onClick={()=>{
          setListView(!listView)
        }}>
          {listView ? <MenuBook /> : <QueueMusicSharp />}
        </IonButton>
          </IonButtons>
         )}
      
     </IonToolbar>
     </IonHeader>
    <IonContent onIonScroll={(e)=>{
        locy = e.detail.scrollTop;
      }} onIonScrollEnd = {()=>{setSpos(locy)}} ref={contentRef} scrollEvents={true} color={colori}>
         <div style={{ height: "2px" }}></div>
     <motion.div exit={{ opacity: 0 }} animate={{ opacity: 1 }} initial={{ opacity: 0 }} transition={{ type: "linear", duration: 0 }}>
      {searchState && !searchText ? (
        <IonItemDivider style={{ backgroundColor: `${color2}`, color: `${color3}`, fontSize: "16px" }}>
         <IonLabel style={{ fontFamily: `${fon}` }}>Recent Searches</IonLabel> 
        </IonItemDivider>
       ) : null} 
      {!searchState ? 
      <>
      {listView ? (
        <div className="whole">
        <div className={"list"}>
        {songsList.map((td, i)=>{
          function next() {
            if(searchState) {
              setSearchHistory(prev=>{
                let dum = [...prev]
                let index = dum.indexOf(searchText);
                if (index !== -1) dum.splice(index, 1)
                for (let k=0; k<dum.length; k++) {
                  if(dum[k]===searchText) {
                    dum.slice(k,1)
                    break
                  }
                }
                dum.push(searchText)
                if(dum.length > 10) {
                  return dum.slice(1)
                }
                return dum
                })
            }
            history.push(`${url}/${td.link}`);
          }
          if (i === 0 || td.name[0] !== songsList[i - 1].name[0])
          return (
           <div key={i}>
            <IonItemDivider id={td.name[0]} style={{ backgroundColor: `${color2}`, color: `${color3}`, fontSize: "16px" }}>
             <IonLabel style={{ fontFamily: `${fon}` }}>{td.name[0]}</IonLabel>
            </IonItemDivider>

            <IonItem button={isPlatform('desktop') ? true : false} color={colori} onClick={next}>
             <IonLabel style={{ fontFamily: `${fon}` }}>
              <h2>{td.name}</h2>
              <p style={{ fontSize: "11px", color: color4 }}>{td.book}</p>
             </IonLabel>
             {td.audio ? <MusicNote style={{ fontSize: "23px" }} />: null}
            </IonItem>
           </div>
          );

         return (
          <IonItem key={i} button={isPlatform('desktop') ? true : false} color={colori} onClick={next}>
           <IonLabel style={{ fontFamily: `${fon}` }}>
            <h2>{td.name}</h2>
            <p style={{ fontSize: "11px", color: color4 }}>{td.book}</p>
           </IonLabel>
           {td.audio ? <MusicNote style={{ fontSize: "23px" }} />: null}
          </IonItem>
         );
        })}
        </div>
        <>{isPlatform("ios")  && !isPlatform("mobileweb") ? <div className="scrollc lhide iphonescroll">
         <div className="iphones"></div>
         <div className="scroll">
          {scrollBar.map((ab,i) => {
           return (
            <button
             onClick={() => {
              const section = document.querySelector(`#${ab}`);
              if (section) {
               section.scrollIntoView({ block: "start", inline: "nearest" });
              }
             }}
             key={i}
             style={{ color: `${clr === "5" || clr === "6" ? "white" : "black"}`, backgroundColor: `${(clr === "5" || clr === "6") ? "#181818" : (clr === "1" ? "#F0F8FF99" : "#FFFFCC99")}` }}
            >
             {ab}
            </button>
           );
          })}
         </div>
         <div style={{ height: "56px", zIndex: "-1" }}></div>
        </div> : <div className="scrollc lhide">
          <div style={{ height: "58px", zIndex: "-1" }}></div>
          <div className="scroll">
           {scrollBar.map((ab, i) => {
            return (
             <button
             key={i}
              onClick={() => {
               const section = document.querySelector(`#${ab}`);
               if (section) {
                if (isPlatform("mobileweb")){
                section.scrollIntoView({ block: "center", inline: "nearest" });
                }else{
                  section.scrollIntoView({ block: "start", inline: "nearest" });
                }
               }
              }}
              style={{ color: `${clr === "5" || clr === "6" ? "white" : "black"}`, backgroundColor: `${(clr === "5" || clr === "6") ? "#181818" : (clr === "1" ? "#F0F8FF99" : "#FFFFCC99")}` }}
             >
              {ab}
             </button>
            );
           })}
          </div>
          <div style={{ height: "56px", zIndex: "-1" }}></div>
         </div>}</>
        </div>
      ) : (
        <>
      <IonItemDivider style={{ backgroundColor: `${color2}`, color: `${color3}` }}>
       <IonLabel style={{ fontFamily: `${fon}` }}>Srila Prabhupada</IonLabel>
      </IonItemDivider>

      <IonItem button={isPlatform('desktop') ? true : false}        color={colori}
       onClick={() => {
       
        history.push(`${url}/Vrindavane Bhajan`);
       }}
      >
       <IonLabel style={{ fontFamily: `${fon}` }}>Vrindavane Bhajan</IonLabel>
      </IonItem>
      <IonItem button={isPlatform('desktop') ? true : false}        color={colori}
       onClick={() => {
       
        history.push(`${url}/Miscellaneous Songs`);
       }}
      >
       <IonLabel style={{ fontFamily: `${fon}` }}> Miscellaneous Songs</IonLabel>
      </IonItem>
      <IonItemDivider style={{ backgroundColor: `${color2}`, color: `${color3}` }}>
       <IonLabel style={{ fontFamily: `${fon}` }}>Bhakti Vinoda Thakura</IonLabel>
      </IonItemDivider>
      <IonItem button={isPlatform('desktop') ? true : false}        color={colori}
       onClick={() => {
       
        history.push(`${url}/Saranagati`);
       }}
      >
       <IonLabel style={{ fontFamily: `${fon}` }}>Saranagati</IonLabel>
      </IonItem>
      <IonItem button={isPlatform('desktop') ? true : false}        color={colori}
       onClick={() => {
       
        history.push(`${url}/Gitavali`);
       }}
      >
       <IonLabel style={{ fontFamily: `${fon}` }}>Gitavali</IonLabel>
      </IonItem>
      <IonItem button={isPlatform('desktop') ? true : false}        color={colori}
       onClick={() => {
       
        history.push(`${url}/Kalyanakalpataru`);
       }}
      >
       <IonLabel style={{ fontFamily: `${fon}` }}>Kalyanakalpataru</IonLabel>
      </IonItem>
      <IonItem button={isPlatform('desktop') ? true : false}        color={colori}
       onClick={() => {
       
        history.push(`${url}/Gitamala`);
       }}
      >
       <IonLabel style={{ fontFamily: `${fon}` }}>Gitamala</IonLabel>
      </IonItem>
      <IonItem button={isPlatform('desktop') ? true : false}        color={colori}
       onClick={() => {
       
        history.push(`${url}/Baula Sangita`);
       }}
      >
       <IonLabel style={{ fontFamily: `${fon}` }}>Baula Sangita</IonLabel>
      </IonItem>
      <IonItemDivider style={{ backgroundColor: `${color2}`, color: `${color3}` }}>
       <IonLabel style={{ fontFamily: `${fon}` }}>Narottama Dasa Thakura</IonLabel>
      </IonItemDivider>
      <IonItem button={isPlatform('desktop') ? true : false}        color={colori}
       onClick={() => {
       
        history.push(`${url}/Prarthana`);
       }}
      >
       <IonLabel style={{ fontFamily: `${fon}` }}>Prarthana</IonLabel>
      </IonItem>
      <IonItem button={isPlatform('desktop') ? true : false}        color={colori}
       onClick={() => {
       
        history.push(`${url}/Prema Bhakti Chandrika`);
       }}
      >
       <IonLabel style={{ fontFamily: `${fon}` }}>Prema Bhakti Chandrika</IonLabel>
      </IonItem>
      <IonItemDivider style={{ backgroundColor: `${color2}`, color: `${color3}` }}>
       <IonLabel style={{ fontFamily: `${fon}` }}>Visvanatha Cakravarti Thakura</IonLabel>
      </IonItemDivider>
      <IonItem button={isPlatform('desktop') ? true : false}        color={colori}
       onClick={() => {
       
        history.push(`${url}/Stavamrita Lahari`);
       }}
      >
       <IonLabel style={{ fontFamily: `${fon}` }}>Stavamrita Lahari</IonLabel>
      </IonItem>
      <IonItemDivider style={{ backgroundColor: `${color2}`, color: `${color3}` }}>
       <IonLabel style={{ fontFamily: `${fon}` }}>Song Books based on Srimad Bhagavatam</IonLabel>
      </IonItemDivider>
      <IonItem button={isPlatform('desktop') ? true : false}        color={colori}
       onClick={() => {
       
        history.push(`${url}/Krsna Lila Stava`);
       }}
      >
       <IonLabel style={{ fontFamily: `${fon}` }}>Krishna Lila Stava</IonLabel>
       <IonNote style={{ fontFamily: `${fon}`, fontSize: "11px", color: color4 }} color={color} mode="ios" slot="end">
        Sanatana Goswami
       </IonNote>
      </IonItem>
      <IonItem button={isPlatform('desktop') ? true : false}        color={colori}
       onClick={() => {
       
        history.push(`${url}/Sri Krsna Vijaya`);
       }}
      >
       <IonLabel style={{ fontFamily: `${fon}` }}>Sri Krishna Vijaya</IonLabel>
       <IonNote style={{ fontFamily: `${fon}`, fontSize: "11px", color: color4 }} color={color} mode="ios" slot="end">
        Gunaraja Khan
       </IonNote>
      </IonItem>
      <IonItem button={isPlatform('desktop') ? true : false}        color={colori}
       onClick={() => {
       
        history.push(`${url}/Gopala Campu`);
       }}
      >
       <IonLabel style={{ fontFamily: `${fon}` }}>Gopala Campu</IonLabel>
       <IonNote style={{ fontFamily: `${fon}`, fontSize: "11px", color: color4 }} color={color} mode="ios" slot="end">
        Jiva Goswami (Abridged)
       </IonNote>
      </IonItem>
      <IonItemDivider style={{ backgroundColor: `${color2}`, color: `${color3}` }}>
       <IonLabel style={{ fontFamily: `${fon}` }}>Compilations</IonLabel>
      </IonItemDivider>
      <IonItem button={isPlatform('desktop') ? true : false}        color={colori}
       onClick={() => {
       
        history.push(`${url}/Sri Ksanada Gita Cintamani`);
       }}
      >
       <IonLabel style={{ fontFamily: `${fon}` }}>Sri Ksanada Gita Cintamani</IonLabel>
       <IonNote style={{ fontFamily: `${fon}`, fontSize: "11px", color: color4 }} color={color} mode="ios" slot="end">
        VCT (Abridged)
       </IonNote>
      </IonItem>
      <IonItem button={isPlatform('desktop') ? true : false}        color={colori}
       onClick={() => {
       
        history.push(`${url}/Songs of the Gaudiya Vaishnava Acaryas`);
       }}
      >
       <IonLabel style={{ fontFamily: `${fon}` }}>Songs of the Gaudiya Vaishnava Acaryas</IonLabel>
      </IonItem>
      <IonItem button={isPlatform('desktop') ? true : false}        color={colori}
       onClick={() => {
       
        history.push(`${url}/The Acaryas Songs Glorifying Lord Gauranga and Govinda`);
       }}
      >
       <IonLabel style={{ fontFamily: `${fon}` }}>Songs Glorifying Lord Gauranga and Govinda</IonLabel>
      </IonItem>
      <IonItem button={isPlatform('desktop') ? true : false}        color={colori}
       onClick={() => {
       
        history.push(`${url}/Songs of Vaishnava Acaryas`);
       }}
      >
       <IonLabel style={{ fontFamily: `${fon}` }}>Songs of the Vaishnava Acaryas</IonLabel>
      </IonItem>
      <IonItem button={isPlatform('desktop') ? true : false}        color={colori}
       onClick={() => {
       
        history.push(`${url}/More Songs of the Vaisnava Acaryas`);
       }}
      >
       <IonLabel style={{ fontFamily: `${fon}` }}>More Songs of the Vaiṣṇava Acaryas</IonLabel>
      </IonItem></>)}
      </> : <>
      {!searchText ? (
       <div>
       {searchHistory.slice().reverse().map((td, i)=>{
         return(
           <IonItem key={i} button={isPlatform('desktop') ? true : false} color={colori} onClick={()=>{search(td)}}>
           <IonLabel style={{ fontFamily: `${fon}` }}>
            <h2>{td}</h2>
           </IonLabel>
          </IonItem>
         )
       })}
     </div>) : (
       <div>
        <IonItemDivider style={{ backgroundColor: `${color2}`, color: `${color3}`, fontSize: "16px" }}>
        <IonLabel style={{ fontFamily: `${fon}` }}>Title</IonLabel>
       </IonItemDivider>

       {searchList.map((val, i) => {
        if (val.title) {
         return (
          <IonItem key={i} button={isPlatform('desktop') ? true : false}              color={colori}
          
           onClick={() => {
              if(searchState) {
                setSearchHistory(prev=>{
                  let dum = [...prev]
                  dum.push(searchText)
                  if(dum.length > 10) {
                    return dum.slice(1)
                  }
                  return dum
                  })
              }
              history.push(`${url}/${val.link}`);
           }}
          >
           <IonLabel style={{ fontFamily: `${fon}` }}>
            <h2>{val.name}</h2>
            <p style={{ fontSize: "11px", color: color4 }}>{val.book}</p>
           </IonLabel>
          </IonItem>
         );
        }
        return null
       })}
       <IonItemDivider style={{ backgroundColor: `${color2}`, color: `${color3}`, fontSize: "16px" }}>
        <IonLabel style={{ fontFamily: `${fon}` }}>Text</IonLabel>
       </IonItemDivider>

       {searchList.map((val, i) => {
        if (!val.title) {
          let sentence = val.line
          const beforeHighlight = sentence.slice(0, val.start);
          const highlighted = sentence.slice(val.start, val.end);
          const afterHighlight = sentence.slice(val.end);
         return (
          <IonItem key={i} button={isPlatform('desktop') ? true : false}              color={colori}
          
           onClick={() => {
              if(searchState) {
                setSearchHistory(prev=>{
                  let dum = [...prev]
                  dum.push(searchText)
                  if(dum.length > 10) {
                    return dum.slice(1)
                  }
                  return dum
                  })
              }
              history.push(`${url}/${val.link}`);
           }}
          >
           <IonLabel style={{ fontFamily: `${fon}` }}>
           <h2>
            {beforeHighlight}
            <span style={{color: "#1e88e5"}}>{highlighted}</span>
            {afterHighlight}
            </h2>
            <p style={{ fontSize: "11px", color: color4 }}>{val.name}</p>
           </IonLabel>
          </IonItem>
         );
        }
        return null
       })}
      </div>

     )}
      </>}
     </motion.div>
     </IonContent>
     <IonFooter>
       <IonToolbar mode="md" color={colorh}>
        <IonSegment value="default">
         <IonSegmentButton style={{ minWidth: 0 }} onClick={() => history.push("/home")}>
          <QueueMusicSharp />
         </IonSegmentButton>
           <IonSegmentButton value="default" style={{ minWidth: 0 }} onClick={() => history.push("/books")}>
            <MenuBookSharp />
           </IonSegmentButton>
           <IonSegmentButton style={{ minWidth: 0 }} onClick={() => history.push("/sp")}>
            <img alt="SP" src={SP} style={{ height: "40px", backgroundColor: colorsp, borderRadius:"50%" }} />
           </IonSegmentButton>
           <IonSegmentButton style={{ minWidth: 0 }} onClick={() => history.push("/sb")}>
            <AutoStoriesSharp />
           </IonSegmentButton>
         <IonSegmentButton style={{ minWidth: 0 }} onClick={() => history.push("/lists")}>
          <PlayLessonSharp />
         </IonSegmentButton>
        </IonSegment>
       </IonToolbar>
       </IonFooter>
     </IonPage>
    </div>
   <Switch location={location}>

    <Route exact path={path}>
    </Route>
    <Route path={`${path}/:name`}>
     <Part />
    </Route>
   </Switch>
   </>
  </AnimatePresence>
 );
}

export default Book;
